import { useEffect, useState } from 'react'
import { getAccounts } from '../api/master'

const TYPES = [['Asset', 'Assets'], ['Liability', 'Liabilities'], ['Equity', 'Equity'], ['Revenue', 'Revenue'], ['Expense', 'Expenses']]
let cache = null

/** The chart of accounts, loaded once per page load. */
export function useAccounts() {
  const [accounts, setAccounts] = useState(cache || [])
  useEffect(() => {
    if (cache) return
    getAccounts().then((a) => { cache = Array.isArray(a) ? a : []; setAccounts(cache) }).catch(() => setAccounts([]))
  }, [])
  return accounts
}

/** For an "expense account" picker: expense accounts, plus Factory labour and
 * Manufacturing overhead (assets that take a cost on its way into production,
 * such as a factory machine's depreciation). Use with types={['Expense', 'Asset']}. */
export const costAccount = (a) => a.type === 'Expense' || !!a.production_cost

/** "1501 · Property and equipment" for a code, or the code alone. */
export const accountLabel = (accounts, code) => {
  const a = accounts.find((x) => x.account_code === code)
  return a ? `${a.account_code} · ${a.account_name}` : (code || '')
}

// A chart-of-accounts dropdown grouped by type. `types` limits it, e.g.
// ['Asset'] or ['Asset', 'Liability']; `filter(account, all)` narrows it more.
export default function AccountSelect({ value, onChange, types, filter, placeholder = 'Choose an account…', ...rest }) {
  const accounts = useAccounts()
  const groups = TYPES.filter(([t]) => !types || types.includes(t))
    .map(([t, label]) => [label, accounts.filter((a) => a.type === t && (!filter || filter(a, accounts)))])
    .filter(([, list]) => list.length)
  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} {...rest}>
      <option value="">{placeholder}</option>
      {groups.map(([label, list]) => (
        <optgroup key={label} label={label}>
          {list.map((a) => <option key={a.account_code} value={a.account_code}>{a.account_code} · {a.account_name}</option>)}
        </optgroup>
      ))}
    </select>
  )
}
